/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSubMenuClick } from "../../../store/slices/SubMenuClick";
import { setData } from "../../../store/slices/TableData";
import Sidebar from "../../../components/AdminComponents/SideNav";
import "../tableStyling.css";
import {
  InteractionTwoTone,
  CheckOutlined,
  CloseOutlined,
  DeleteTwoTone,
  UserOutlined,
} from "@ant-design/icons";
import {
  Table,
  Tag,
  Input,
  Button,
  Spin,
  Popconfirm,
  Pagination,
  Badge,
  Menu,
  Switch,
  Dropdown,
} from "antd";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { setSubMenuTrakL } from "../../../store/slices/SubMenuTrakL";
import { message } from "antd";
import { setTnmisSubmenu } from "../../../store/slices/tnmisSubmenu";
import {
  capitalizeWords,
  ModuleColor,
  ModuleTagName,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { getViewStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import FilterCustomers from "../../../components/AdminComponents/Modals/FilterCustomers";
import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";
import { setCustomerFilterDataRedux } from "../../../store/slices/customerfilterSlice";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import UserImpersonateModal from "../../../components/AdminComponents/Modals/UserImpersonateModal";

const Customers = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();
  const history = useNavigate();
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState(["True"]);
  const [relationshipType, setRelationshipType] = useState([]);
  const [clientType, setClientType] = useState([]);

  const [naicsRes, setNaicsRes] = useState([]);
  const [applications, setApplications] = useState([]);
  const [selectedNaics, setSelectedNaics] = useState("");
  const [customerToClient, setCustomerToClient] = useState(false);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const filterData = useSelector((state) => state.customerfilter);
  const [data, setData] = useState([]);
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();

  // const [filterData, setFilterData] = useState({
  //   pageSize: 15,
  //   currentPage: 1,
  //   url: `/suborganizationlist/`,
  //   filter_flag: false,
  //   search: "",
  //   filters: "",
  // });
  const { pageSize, currentPage, url, filter_flag, search, filters } =
    filterData;
  //console.log(url);
  //console.log(url, "clientFilter");
  const userInfo = useSelector((state) => state.user);
  const handleStatusChange = (e) => {
    setStatus([e.target.value]);
  };

  const ResetFields = async () => {
    //console.log("reset from modal");
    setStatus(["True"]);
    setActive(true);
    setRelationshipType([]);
    setClientType([]);
    setNaicsRes([]);
    setSelectedNaics("");
    setCustomerToClient(false);
    setSelectedApplications([]);
    handleCancel();
    dispatch(
      setCustomerFilterDataRedux({
        pageSize: 15,
        currentPage: 1,
        url: `/suborganizationlist/`,
        filter_flag: false,
        search: "",
        filters: "",
      })
    );
  };

  const handleRelationshipTypeChange = (checkedValues) => {
    setRelationshipType(checkedValues);
  };

  const handleClientTypeChange = (checkedValues) => {
    setClientType(checkedValues);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const handleApply = async () => {
    //console.log(selectedApplications);

    if (status.length === 0) {
      message.error("Please select at least one status.");
      return;
    } else {
      if (status.length === 1 && status[0] === "False") {
        setActive(false);
      } else {
        setActive(true);
      }
      // setLoading(true);
      let filter_url = "";

      if (selectedNaics !== "") {
        filter_url += `&parent_key=${selectedNaics}`;
      }

      if (selectedApplications.length > 0) {
        filter_url += `&application=${selectedApplications.join(",")}`;
      }
      if (customerToClient) {
        filter_url += `&customer_to_client=True`;
      }
      // console.log(filter_url, "filter_url");
      if (filter_url === "" && status.length === 1 && status[0] === "True") {
        dispatch(
          setCustomerFilterDataRedux({
            ...filterData,
            filter_flag: false,
            currentPage: 1,
            filters: "",
            search: "",
          })
        );
        // setCustomerFilterDataRedux(() => ({
        //   ...filterData,
        //   filter_flag: false,
        //   currentPage: 1,
        //   search: "",
        // }));
      } else {
        //console.log(active, "active2");
        dispatch(
          setCustomerFilterDataRedux({
            ...filterData,
            filter_flag: true,
            filters: filter_url,
            currentPage: 1,
          })
        );
        // setCustomerFilterDataRedux(() => ({
        //   ...filterData,
        //   filter_flag: true,
        //   filters: filter_url,
        //   currentPage: 1,
        //   // pageSize: 15,
        // }));
      }

      //console.log(url);
      // console.log(filterData)

      setVisible(false);
    }
  };
  const showModal = () => {
    console.log("showModal called! Setting visible to true.");
    setVisible(true);
    console.log(visible);
  };
  const LoadUser = async () => {
    try {
      const res = await Axios.get("/applicationlist/?status=True");
      //console.log(res.data);
      setApplications(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    localStorage.removeItem("impersonateCheck");
  }, []);

  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };

  // function getDaySuffix(day) {
  //   if (day >= 11 && day <= 13) {
  //     return "th";
  //   }
  //   switch (day % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // }
  const [isUserImpersonateModalVisible, setIsUserImpersonateModalVisible] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordDetails, setSelectedRecordDetails] = useState(null);
  const impersonateUserAccount = (user_id, client_id) => {
    //console.log(id);
    localStorage.setItem("impersonateOriginalID", userInfo?.data?.id);
    localStorage.setItem("impersonateCheck", "is-superadmin-imp");
    localStorage.setItem("impersonateLoginID", user_id);
    localStorage.setItem("impersonateLoginClientID", client_id);
    history("/traineryone/user/impersonate/login");
  };
  const handleUserImpersonateClick = (record) => {
    setIsUserImpersonateModalVisible(true);
    setSelectedRecord(record);
    setSelectedRecordDetails(record);
  };
  const handleUserImpersonateModalClose = () => {
    setIsUserImpersonateModalVisible(false);
    setSelectedRecord(null);
    setSelectedRecordDetails(null);
  };
  const impersonateMenu = (record) => (
    <Menu>
      <Menu.Item
        key="user-impersonate"
        onClick={() => handleUserImpersonateClick(record)}
        icon={<UserOutlined style={{ color: "#52c41a" }} />} // Icon for User Impersonate
      >
        User Impersonate
      </Menu.Item>
    </Menu>
  );
  const columns2 = [
    {
      title: capitalizeWords("customer id"),
      dataIndex: "client_id",
      key: "client_id",
      fixed: "left",
      width: 120,
    },
    {
      title: capitalizeWords("customer name"),
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 200,
    },
    // {
    //   title: "NAICS DETAILS",
    //   dataIndex: "naics_primary",
    //   key: "naics_primary",
    // },
    {
      title: capitalizeWords("customer's trainery client id"),
      dataIndex: "trainery_client_id",
      key: "trainery_client_id",
      width: 260,
      // render: (parent_key) => <span>{parent_key?.client_id}</span>,
    },
    {
      title: capitalizeWords("customer type"),
      dataIndex: "org_type",
      key: "org_type",
      width: 150,
    },
    {
      title: capitalizeWords("products"),
      dataIndex: "applications",
      key: "applications",
      width: 150,
      render: (applications) => (
        <span>
          {applications.map((tag, index) => {
            return (
              <Tag
                color={ModuleColor(tag.name)}
                key={index}
                title={tag.name}
                style={{ margin: "3px" }}
              >
                <span style={{ color: "black", fontWeight: "500" }}>
                  {ModuleTagName(tag.name)}
                </span>
              </Tag>
            );
          })}
        </span>
      ),
    },
    {
      title: capitalizeWords("users"),
      dataIndex: "user_count",
      key: "user_count",
      width: 80,
    },

    // {
    //   title: "Products",
    //   dataIndex: "applications",
    //   key: "applications",

    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag) => {
    //         console.log(tag);
    //         let color;
    //         if (tag === "Trak Coaching") {
    //           color = "volcano";
    //         } else if (tag === "Trak Learning") {
    //           color = "blue";
    //         } else if (tag === "DelegateHR") {
    //           color = "green";
    //         }
    //         return (
    //           <Tag color={color} key={tag} title={tag}>
    //             {typeof tag === "string"
    //               ? tag.substring(0, 2).toUpperCase()
    //               : ""}
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },

    {
      title: capitalizeWords("access start"),
      dataIndex: "contract_start_date",
      key: "contract_start_date",
      width: 150,
      render: GetFormattedDate,
    },
    {
      title: capitalizeWords("access end"),
      dataIndex: "contract_end_date",
      key: "contract_end_date",
      width: 140,
      render: GetFormattedDate,
    },

    // {
    //   title: "PURPOSE",
    //   dataIndex: "purpose",
    //   key: "purpose",
    //   width: 150,
    // },

    // {
    //   title: "CREATED AT",
    //   dataIndex: "created_at",
    //   key: "created_at",
    //   render: (text, record) => {
    //     const date = new Date(text);
    //     const month = date
    //       .toLocaleString("default", { month: "short" })
    //       .toUpperCase();
    //     const day = date.getDate();
    //     const suffix = getDaySuffix(day);
    //     const year = date.getFullYear();
    //     const formattedDate = `${day} ${month} ${year}`;
    //     return formattedDate;
    //   },
    // },
    {
      title: capitalizeWords("updated"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 120,
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" });
        const day = date.getDate();
        //const suffix = getDaySuffix(day);
        const year = date.getFullYear();
        const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
        return formattedDate;
      },
    },
    {
      title: capitalizeWords("status"),
      dataIndex: "status",
      key: "status",
      align: "center",
      render: renderStatus,
      width: 80,
    },
    {
      title: capitalizeWords("customer of"),
      dataIndex: "parent_key",
      key: "parent_key",
      width: 280,
      render: (parent_key) => <span>{parent_key?.name}</span>,
    },
    {
      title: capitalizeWords("ACTIONS"),
      dataIndex: "actions",
      key: "actions",
      fixed: "right",
      width: 100,
      align: "center",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation(); // this will avoid onRow being called
            // go to placeUrl(routes.platformDetails, {})
          },
        };
      },
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {record?.applications?.length > 0 && record?.user_count > 0 && (
            <Dropdown overlay={impersonateMenu(record)} trigger={["click"]}>
              <InteractionTwoTone
                style={{
                  cursor: "pointer",
                  fontSize: "2rem",
                  marginRight: "0.9rem",
                }}
                title="Impersonate"
              />
            </Dropdown>
          )}
        </div>
      ),
    },
  ];
  const onShowSizeChange = (page, size) => {
    dispatch(
      setCustomerFilterDataRedux({
        ...filterData,
        pageSize: size,
      })
    );
    // setCustomerFilterDataRedux((prevData) => ({
    //   ...prevData,
    //   pageSize: size,
    // }));
  };

  const onPageChange = (page) => {
    dispatch(
      setCustomerFilterDataRedux({
        ...filterData,
        currentPage: page,
      })
    );
    // setCustomerFilterDataRedux((prevData) => ({
    //   ...prevData,
    //   currentPage: page,
    // }));
  };
  useEffect(() => {
    dispatch(setSubMenuClick(false));
    dispatch(setSubMenuTrakL(false));
    dispatch(setTnmisSubmenu(false));
    localStorage.removeItem("impersonateCheck");
  }, [dispatch]);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const impersonateUser = (id) => {
    //console.log(id);
    localStorage.setItem("impersonateOriginalID", userInfo?.data?.id);
    localStorage.setItem("impersonateCheck", "is-superadmin-imp");
    localStorage.setItem("impersonateLoginID", id);
    history("/traineryone/client/impersonate/login");
  };
  const handleDelete = async (record) => {
    const updatedValues = {
      status: false,
      client_id: record.client_id,
      name: record.name,
    };
    try {
      const res = await Axios.put(
        `/organization/${record.id}/`,
        updatedValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      handleApply();
      CreateSuccessfull("Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed("Archived");
    }
  };
  const handleDelete2 = async (record) => {
    const updatedValues = {
      status: true,
      client_id: record.id,
      name: record.name,
    };
    try {
      const res = await Axios.put(
        `/organization/${record.id}/`,
        updatedValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      handleApply();
      CreateSuccessfull("Unarchived");
    } catch (err) {
      //console.log(err);
      CreateFailed("Unarchived");
    }
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Client has been ${props}.`,
      duration: 5,
    });
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Client have not been ${props}.`,
      duration: 5,
    });
  };

  const handleRowClick = (record) => {
    if (getViewStatus1(userInfo, 3, 0)) {
      history(`/admin-manager/customers/profile/${record}`);
    }
  };

  const fetchTableData = async () => {
    let doNothing = false;
    const { pageSize, currentPage, url, filter_flag, search, filters } =
      filterData;
    // console.log(filters, "THis is filters")
    //console.log(filter_flag , "this is the filter flag which should show the status of the filter")
    let passUrl = `${url}?page=${currentPage}&page_size=${pageSize}`;
    if (search?.length > 0) {
      if (search.length > 2) {
        if (filter_flag) {
          passUrl += `&search=${search}&status=${
            active ? "True" : "False"
          }${filters}`;
        } else {
          passUrl += `&search=${search}&status=${active ? "True" : "False"}`;
        }
      } else {
        doNothing = true;
      }
    }
    if (filter_flag) {
      passUrl += `&status=${active ? "True" : "False"}${filters}`;
    } else {
      passUrl += `&status=${active ? "True" : "False"}`;
    }
    // console.log(passUrl, filter_flag, filters, "URL FILTER_FLAG AND FILTERS")
    if (!doNothing) {
      setLoading(true);
      try {
        const response = await Axios.get(passUrl);

        setData(response.data.results);
        setItemsLength(response.data.count);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching table data:", error);
      }
    }
  };

  const handleSearchChange = (event) => {
    dispatch(
      setCustomerFilterDataRedux({
        ...filterData,
        search: event.target.value,
        currentPage: 1,
        // pageSize: 15,
      })
    );
    // setCustomerFilterDataRedux((prevData) => ({
    //   ...prevData,
    //   search: event.target.value,
    //   currentPage: 1,
    //   // pageSize: 15,
    // }));
  };
  const handleSwitchChange = (checked) => {
    setActive(checked);
    dispatch(
      setCustomerFilterDataRedux({
        ...filterData,
        search: "",
        currentPage: 1,
        random: Math.random(),
      })
    );
  };
  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  return (
    <div>
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <CommonTopDetails
          title="Customers Summary"
          titleSuffix={`${itemsLength || 0} customer(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          showAddButton={false}
          filterAction={true}
          filterUrl={filter_flag}
          filterButtonProps={{
            modalType: "PopUP",
            modalProps: showModal,
          }}
          resetButtonProps={{
            modalProps: ResetFields,
          }}
          customContent={
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
          }
        />

        <div className="form-container-3">
          <Spin spinning={loading}>
            <div
              className="table-wrapper"
              style={{ overflowX: "auto", overflowY: "auto" }}
            >
              <Table
                columns={columns2}
                size="small"
                bordered
                rowKey="id"
                scroll={{
                  x: 1000,
                  y: `${remainingViewportHeight(24)}px`,
                }}
                pagination={false}
                onRow={(record) => ({
                  onClick: (event) => {
                    if (
                      event.target.closest(
                        ".ant-table-cell[data-index='actions']"
                      )
                    ) {
                      return;
                    }

                    handleRowClick(record.id);
                  },
                })}
                dataSource={data}
                className="table-container"
                style={{ margin: "1rem" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "1rem",
                }}
              >
                <Pagination
                  size="small"
                  showSizeChanger
                  onShowSizeChange={onShowSizeChange}
                  onChange={onPageChange}
                  pageSizeOptions={["10", "15", "30", "50", "100"]}
                  showQuickJumper
                  current={currentPage}
                  defaultPageSize={pageSize}
                  total={itemsLength}
                />
              </div>
            </div>
          </Spin>
          <FilterCustomers
            visible={visible}
            status={status}
            setStatus={setStatus}
            relationshipType={relationshipType}
            clientType={clientType}
            naicsRes={naicsRes}
            applications={applications}
            setApplications={setApplications}
            selectedApplications={selectedApplications}
            setSelectedApplications={setSelectedApplications}
            setNaicsRes={setNaicsRes}
            selectedNaics={selectedNaics}
            customerToClient={customerToClient}
            setCustomerToClient={setCustomerToClient}
            handleCancel={handleCancel}
            handleApply={handleApply}
            setSelectedNaics={setSelectedNaics}
            handleStatusChange={handleStatusChange}
            handleClientTypeChange={handleClientTypeChange}
            handleRelationshipTypeChange={handleRelationshipTypeChange}
            ResetFields={ResetFields}
            page={currentPage}
            size={pageSize}
          />
        </div>
      </Sidebar>
      <UserImpersonateModal
        isUserImpersonateModalVisible={isUserImpersonateModalVisible}
        handleUserImpersonateModalClose={handleUserImpersonateModalClose}
        selectedRecord={selectedRecord?.id}
        selectedRecordDetails={selectedRecordDetails || null}
        impersonateUserAccount={impersonateUserAccount}
      />
    </div>
  );
};

export default Customers;
